<template>
  <div>
    <List
      v-if="!isLoading"
      listing="group"
      :fields="fields"
      order-by="end_date: desc, start_date: asc"
      search-text="Rechercher une promotion"
      :pageSize="pageSize"
      edit-route-name="promotions-edit"
    >
      <template v-slot:buttons>
        <div class="md:flex flex-row justify-around hidden md:w-1/3">
          <button
            v-if="!isReadOnly"
            type="button"
            class="twn-button whitespace-no-wrap overflow-hidden text-xs mr-2"
            @click="onAddPromotionClick"
          >
            Ajouter une nouvelle promotion
          </button>
        </div>
      </template>
    </List>
  </div>
</template>

<script>
import List from "@/components/List";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    List,
  },
  props: {
    pageSize:{
      type: Number,
      default: 30,
      required: false
    }
  },
  data: () => ({
    isLoading: true,
    fields: [
      {
        key: "identifier",
        label: "Identifiant",
        sortable: true,
      },    
      {
        key: "name",
        label: "Nom",
        sortable: true,
      },
      {
        key: 'customer',
        label: "Client",
        sortable: true,
        db: `customer {
          identifier
          name
        }`,
        formatter: (value) => {
          if (!value)
            return 'Aucun'

          return [value.identifier, value.name].filter(str => str || false).join(' - ') || '~ Client supprimé ~'
        }
      },
      {
        key: 'start_date',
        db: `start_date
        end_date`,
        label: "Dates",
        sortable: true,
        formatter: (value, key, item) => {
          const start = (item.start_date ? item.start_date.split('-').reverse().join('/') : '')
          const end = (item.end_date ? item.end_date.split('-').reverse().join('/') : '')

          return start + ' - ' + end
        }
      },
      {
        key: 'disabled',
        label: 'Statut',
        sortable: true,
        formatter: (value, key, item) => {
          if (value)
            return 'Suspendue'

          const now = new Date()
          const start = new Date(item.start_date)
          const end = new Date(item.end_date)

          return (now < start ? 'À venir' : (now > end ? 'Passé' : 'En cours'))
        }
      },
      {
        key: 'users_aggregate',
        label: "Stagiaires",
        sortable: true,
        db: `users_aggregate(where: {
          user: {
            role: { _eq: "user" },
          }
        }) {
          aggregate {
            count
          }
        }`,
        nested: 'count'
      },
      {
        label: 'Actifs',
        sortable: true,
        key: 'actives',
        nested: 'count',
        db: `actives: users_aggregate(where: {user: {
          role: { _eq: "user" },
          cognito_confirmed: {_eq: true}}}) {
          aggregate {
            count
          }
        }`
      },
      {
        label: 'Niv 1 terminé',
        sortable: true,
        key: 'level1',
        nested: 'count',
        db: `level1: users_aggregate(where: {user: {
          role: { _eq: "user" },
          user_logs: {type: {slug: {_eq: "course"}}, data_key: {_eq: "LVL_UUID"}}}}) {
          aggregate {
            count
          }
        }`
      },
      {
        label: 'Niv 2 terminé',
        sortable: true,
        key: 'level2',
        nested: 'count',
        db: `level2: users_aggregate(where: {user: {
          role: { _eq: "user" },
          user_logs: {type: {slug: {_eq: "course"}}, data_key: {_eq: "LVL_UUID"}}}}) {
          aggregate {
            count
          }
        }`
      }
    ],
  }),
  computed: {
    ...mapState('Auth', [ 'userInfo' ]),
    isSuperAdmin() {
      return (this.userInfo && this.userInfo.role == 'superadmin')
    },
    isReadOnly() {
      return !this.isSuperAdmin
    }
  },
  async mounted() {
    this.isLoading = true

    const level1 = await this.$store.dispatch('Course/GetCourseIDByType', 'mission')
    const level2 = await this.$store.dispatch('Course/GetCourseIDByType', 'investigation')

    if (level1) {
      this.fields[this.fields.length - 2].db = this.fields[this.fields.length - 2].db.replace('LVL_UUID', level1)
    }

    if (level2) {
      this.fields[this.fields.length - 1].db = this.fields[this.fields.length - 1].db.replace('LVL_UUID', level2)
    }

    this.isLoading = false
  },
  methods: {
    ...mapActions("EditItem", ["clearCurrentID"]),
    onAddPromotionClick() {
      this.clearCurrentID();
      this.$router.push({ name: "promotions-create" });
    },
  },
};
</script>